/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */

export enum LocalclassificationTypes {
  LOCAL_CLASSIFICATION_REQUEST = '@LOCAL_CLASSIFICATION_REQUEST',
  LOCAL_CLASSIFICATION_REQUEST_SUCCCES = '@LOCAL_CLASSIFICATION_REQUEST_SUCCCES',
  LOCAL_CLASSIFICATION_REQUEST_FAILURE = '@LOCAL_CLASSIFICATION_REQUEST_FAILURE',
}

export interface LocalclassificationState {
  codigo: number;
  nome: string;
}

export interface LocalclassificationStateReducer{
  readonly data: Array<LocalclassificationState>;
}

export const SET_CLASSIFICATION = 'SET_CLASSIFICATION';

interface SetClassification{
  type: typeof SET_CLASSIFICATION;
  payload: Array<LocalclassificationState>;
}

interface RequestClassification{
  type: typeof LocalclassificationTypes.LOCAL_CLASSIFICATION_REQUEST;
}

export type LocalclassificationType = | SetClassification | RequestClassification
